<template>
  <v-container fluid>
    <v-layout align-center justify-center> 
      <v-flex xs12 sm8 md4>
        <img src="/src/assets/logo.png" alt="">
        <v-card class="elevation-10">
          <v-toolbar light color="primary lighten-5">
            <v-toolbar-title to="/">Sign Up</v-toolbar-title>
          </v-toolbar>
          <v-flex xs12 sm6 offset-sm3 mt-5>
            <form @submit.prevent="userSignUp">
              <v-layout column>
                <v-flex>
                  <v-text-field
                    prepend-icon="email"
                    name="email"
                    label="Email"
                    id="email"
                    type="email"
                    v-model="email"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex>
                  <v-text-field
                    prepend-icon="lock"
                    name="password"
                    label="Password"
                    hint="At least 8 characters"
                    id="password"
                    min="8"
                    :append-icon="password_visibility ? 'visibility' : 'visibility_off'"
                    :append-icon-cb="() => (password_visibility = !password_visibility)"
                    value="Password"
                    :rules="[comparePasswords]"
                    error
                    :type="password_visibility ? 'password' : 'text'"
                    v-model="password"
                  ></v-text-field>
                </v-flex>
                <v-flex>
                  <v-text-field
                    prepend-icon="lock"
                    name="confirmPassword"
                    label="Confirm Password"
                    hint="At least 8 characters"
                    id="confirmPassword"
                    min="8"
                    :append-icon="confirm_visibility ? 'visibility' : 'visibility_off'"
                    :append-icon-cb="() => (confirm_visibility = !confirm_visibility)"
                    value="Password"
                    :rules="[comparePasswords]"
                    error
                    :type="confirm_visibility ? 'password' : 'text'"
                    v-model="passwordConfirm"
                  ></v-text-field>
                </v-flex>
                <v-flex class="text-xs-right" mb-5>
                  <v-btn color="primary" type="submit">Submit</v-btn>
                </v-flex>
              </v-layout>
            </form>
          </v-flex>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      password_visibility: true,
      confirm_visibility: true,
      email: "",
      password: "",
      passwordConfirm: ""
    };
  },
  computed: {
    comparePasswords() {
      return this.password === this.passwordConfirm
        ? true
        : "Passwords don't match";
    }
  },
  methods: {
    userSignUp() {
      if (this.comparePasswords !== true) {
        return;
      }
      this.$store.dispatch("userSignUp", {
        email: this.email,
        password: this.password
      });
    }
  }
};
</script>

<style scoped>
</style>
